export default "__VITE_ASSET__BiE0Lfz8__"